// Regime x grundlag -> Smartvilkår-klausul (Vilkår-trinnet).
//
// Spejler docs/canonical-facts.yaml -> lejeloven.regime_clauses. Ret manifestet
// FØRST; drift-testen backend/auth/tests/test_regime_clause_canonical_facts.py
// fejler hvis de to ikke er ens. Klausulteksterne ligger i SectionVilkaar.tsx.
//
// Wizarden FORESLÅR kun en klausul. Landlord kan altid fravælge den.

export type RentRegime = '' | 'ureguleret' | 'reguleret'
export type RegimeGrundlag = 'post1991' | 'erhverv1991' | 'tagetage'

export interface RegimeClauseResult {
  ids: string[]
  status: 'afklaret' | 'uafklaret'
  alternative?: string[]
}

const REGIME_CLAUSES: Record<'ureguleret' | 'reguleret', Record<RegimeGrundlag, string[]>> = {
  ureguleret: {
    post1991: ['sv-02'],
    erhverv1991: ['sv-03'],
    tagetage: ['sv-04'],
  },
  reguleret: {
    post1991: ['sv-06'],
    erhverv1991: ['sv-07'],
    tagetage: ['sv-08'],
  },
}

// Nr. 3 nypåbygget etage kan ikke udledes af Generelt-trinnet; tilbydes kun manuelt.
const REGIME_CLAUSE_ALTERNATIVES: Record<'ureguleret' | 'reguleret', Partial<Record<RegimeGrundlag, string[]>>> = {
  ureguleret: {
    tagetage: ['sv-05'],
  },
  reguleret: {
    tagetage: ['sv-09'],
  },
}

const GRUNDLAG: RegimeGrundlag[] = ['post1991', 'erhverv1991', 'tagetage']

/**
 * Udleder foreslåede klausuler. Uafklaret (intet forvalg) når fravalg af
 * husleje ikke er valgt, begrundelsen er tom/fri tekst (custom), eller regimet
 * ikke er valgt.
 */
export function regimeClauses(
  freeRent: boolean,
  freeRentReason: string,
  rentRegime: RentRegime | undefined,
): RegimeClauseResult {
  if (!freeRent || (rentRegime !== 'ureguleret' && rentRegime !== 'reguleret')) {
    return { ids: [], status: 'uafklaret' }
  }
  const grundlag = GRUNDLAG.find(g => g === freeRentReason)
  if (!grundlag) return { ids: [], status: 'uafklaret' }
  const alternative = REGIME_CLAUSE_ALTERNATIVES[rentRegime][grundlag]
  return {
    ids: [...REGIME_CLAUSES[rentRegime][grundlag]],
    status: 'afklaret',
    ...(alternative ? { alternative: [...alternative] } : {}),
  }
}
